import { Buffer } from "buffer";
import { FC } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { RouteProps } from "./types";

const PublicRoute: FC<RouteProps> = ({ isLoggedIn }) => {
    const [searchParams] = useSearchParams();

    const redirectTo = searchParams.get("redirectTo");

    const redirectToURL = Buffer.from(
        searchParams.get("redirectTo") ?? "",
        "base64"
    ).toString("utf-8");

    if (isLoggedIn && !!redirectTo) {
        return <Navigate to={redirectToURL} />;
    } else if (isLoggedIn) return <Navigate to="/" />;
    else return <Outlet />;
};

export default PublicRoute;
